if (!customElements.get('gb-rotor-grid')) {
  class GBRotorGrid extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('[data-rotor-controls]');
      this.grid = this.querySelector('#product-grid');
      this.cards = [...this.querySelectorAll('[data-rotor-card]')];
      this.fields = [...this.form.querySelectorAll('[name]')];
      this.collator = new Intl.Collator(document.documentElement.lang, {numeric:true, sensitivity:'base'});
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.form.hidden = false;
      this.querySelector('details').open = matchMedia('(min-width:750px)').matches;
      this.form.addEventListener('submit', event => { event.preventDefault(); this.apply(true); }, options);
      this.form.addEventListener('change', () => { clearTimeout(this.timer); this.apply(true); }, options);
      this.form.addEventListener('input', event => {
        if (event.target.type !== 'number') return;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.apply(true), 250);
      }, options);
      this.querySelectorAll('[data-rotor-reset]').forEach(button => button.addEventListener('click', () => {
        clearTimeout(this.timer); this.form.reset(); this.apply(true);
      }, options));
      window.addEventListener('popstate', () => {this.readURL(); this.apply(false);}, options);
      this.readURL(); this.apply(false);
    }
    disconnectedCallback() {this.abort?.abort(); clearTimeout(this.timer); this.ready = false;}
    readURL() {
      const params = new URL(location.href).searchParams;
      this.form.reset();
      const legacy = {gb_brand:'filter.p.vendor',gb_min:'filter.v.price.gte',gb_max:'filter.v.price.lte',gb_sort:'sort_by'};
      for (const field of this.fields) {
        const value = params.get(field.name) ?? (legacy[field.name] ? params.get(legacy[field.name]) : null);
        if (value === null) continue;
        if (field.tagName === 'SELECT') {
          if ([...field.options].some(option => option.value === value)) field.value = value;
        } else if (value !== '' && Number.isFinite(Number(value)) && Number(value) >= 0) field.value = value;
      }
    }
    apply(updateURL) {
      const values = Object.fromEntries(this.fields.map(field => [field.name,field.value]));
      const min = values.gb_min === '' ? 0 : Math.max(0,Number(values.gb_min))*100;
      const max = values.gb_max === '' ? Infinity : Math.max(0,Number(values.gb_max))*100;
      let count = 0;
      for (const card of this.cards) {
        const d = card.dataset;
        const matches = (!values.gb_brand || d.brand === values.gb_brand) &&
          (!values.gb_mount || d.mount === values.gb_mount) &&
          (!values.gb_diameter || d.sizes.split(',').includes(values.gb_diameter)) &&
          (!values.gb_thickness || Number(d.thickness) === Number(values.gb_thickness)) &&
          (!values.gb_stock || (d.available === 'true') === (values.gb_stock === 'in-stock')) &&
          Number(d.price) >= min && Number(d.price) <= max;
        card.hidden = !matches;
        if (matches) count++;
      }
      const sorted = [...this.cards].sort((a,b) => {
        const x = a.dataset, y = b.dataset;
        let order = 0;
        switch (values.gb_sort) {
          case 'price-ascending': order = Number(x.price)-Number(y.price); break;
          case 'price-descending': order = Number(y.price)-Number(x.price); break;
          case 'title-ascending': order = this.collator.compare(x.title,y.title); break;
          case 'title-descending': order = this.collator.compare(y.title,x.title); break;
          case 'created-descending': order = Number(y.created)-Number(x.created); break;
          default: order = Number(y.available==='true')-Number(x.available==='true');
        }
        return order || Number(x.order)-Number(y.order);
      });
      sorted.forEach(card => this.grid.append(card));
      this.querySelector('[data-rotor-count]').textContent = this.dataset.countTemplate.replace('__COUNT__',count).replace('__TOTAL__',this.cards.length);
      this.querySelector('[data-rotor-empty]').hidden = count !== 0;
      if (updateURL) {
        const url = new URL(location.href);
        for (const key of [...url.searchParams.keys()]) if (key.startsWith('filter.') || key === 'sort_by' || key === 'page') url.searchParams.delete(key);
        for (const [key,value] of Object.entries(values)) {
          if (value && !(key==='gb_sort' && value==='featured')) url.searchParams.set(key,value);
          else url.searchParams.delete(key);
        }
        if (url.href !== location.href) history.pushState({},'',url);
      }
    }
  }
  customElements.define('gb-rotor-grid', GBRotorGrid);
}
